import axiosClient from '@/core/api/axiosClient';
import { MENU_ENDPOINTS } from './endpoints';

export interface MenuAcceso {
  id: number;
  nombre: string;
  url: string | null;
}

export interface MenuItem {
  id: number;
  nombre: string;
  descripcion?: string | null;
  url: string;
  icono?: string | null;
  orden: number;
  padreId?: number | null;
  activo: boolean;
  accesos: MenuAcceso[];
  hijos?: MenuItem[];
}

export interface ApiResponse<T> {
  data?: T;
  message?: string;
  success: boolean;
  errors?: string[];
}

export const menuClient = {
  /**
   * Obtiene el menú del usuario autenticado basado en sus roles
   */
  getMenuUsuario: async (): Promise<ApiResponse<MenuItem[]>> => {
    const response = await axiosClient.get<ApiResponse<MenuItem[]>>(
      MENU_ENDPOINTS.BASE
    );
    return response.data;
  },
};

